import { useQuery } from '@tanstack/react-query';

import getStudio from 'Api/studio/getStudio';

import getAllStudiosResponse from './model/response/getAllStudiosResponse';

const useGetAllStudio = () =>
  useQuery({
    queryKey: ['all-studios'],
    queryFn: async () => {
      const response = await getStudio();

      const result = getAllStudiosResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

export default useGetAllStudio;
